import { useContext } from 'react'
import {
  UpgradePlanModalContext,
  type UpgradePlanModalContextValue,
} from '../components/UpgradePlanModalProvider'

export function useUpgradePlanModal(): UpgradePlanModalContextValue {
  const context = useContext(UpgradePlanModalContext)

  if (!context) {
    throw new Error(
      'useUpgradePlanModal must be used within an UpgradePlanModalProvider'
    )
  }

  return context
}
